import React from 'react'

const VariationOrderForm = () => {
    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card" id={1}>
                    <div className="card-body">
                        <div className="checklist-title-bx">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="text-center">
                                        <h4>(Potential) Variation Order Form</h4>
                                        <p>
                                            Following to be checked and confirmed before official delivery
                                            of the vessel
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 ">
                                <div className="report-index-top">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className="hd-s2 w150">
                                                    <p>Yard</p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <div className="hull-select-box">
                                                        <select className="form-select">
                                                            <option>Select Yard Number</option>
                                                            <option>CL-001</option>
                                                            <option>CL-002</option>
                                                            <option>CL-003</option>
                                                            <option>CL-004</option>
                                                        </select>
                                                    </div>
                                                </td>
                                                <td className="hd-s2 pl10 w150">
                                                    <p>Hull No</p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <div className="hull-select-box">
                                                        <select className="form-select">
                                                            <option>Select Hull Number</option>
                                                            <option>CL-001</option>
                                                            <option>CL-002</option>
                                                            <option>CL-003</option>
                                                            <option>CL-004</option>
                                                        </select>
                                                    </div>
                                                </td>
                                                <td className="hd-s2 pl10 w150">
                                                    <p>Owner</p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Owner Name"
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="hd-s2 w150">
                                                    <p>Date</p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Date"
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="hd-s2 pl10 w150">
                                                    <p>Originated By</p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <select className="form-select">
                                                        <option>Select Originated By</option>
                                                        <option>Owner</option>
                                                        <option>Yard</option>
                                                    </select>
                                                </td>
                                                <td className="hd-s2 pl10 w150">
                                                    <p>Yard Reference</p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Yard Reference"
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="hd-s2 w150">
                                                    <p>Site Query ref No </p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Query ref No"
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="hd-s2 pl10 w150">
                                                    <p>Subject</p>
                                                </td>
                                                <td className="td-input-bx" colSpan="">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Give brief description"
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="note-info">
                                    <p>
                                        Enter (P)VO number/ date of issue/ Originator/ Subject as above
                                        in Variation Order Index
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 ">
                                <div className="appraisal-report-table-responsive">
                                    <table className="assessment-table" cellSpacing={0}>
                                        <tbody>
                                            <tr className="tr-info">
                                                <td colSpan={3} className="">
                                                    <p className="text-left">
                                                        <b>NNNN:</b>Serial Number starting from 0001
                                                    </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="hd-s2 pd10">
                                                    {" "}
                                                    <p>S.No.</p>
                                                </td>
                                                <td className="hd-s2 pd10 w300" colSpan={2}>
                                                    <p className="text-left">(P) VO Reference to</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">1.</p>
                                                </td>
                                                <td className="tb-input-value pl10 hd-s2 w300">
                                                    <p className="text-left">Contract Clause</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">2.</p>
                                                </td>
                                                <td className="tb-input-value pl10 hd-s2">
                                                    <p className="text-left">Specification reference</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">3.</p>
                                                </td>
                                                <td className="tb-input-value pl10 hd-s2">
                                                    <p className="text-left">Drawing No</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">4.</p>
                                                </td>
                                                <td className="tb-input-value pl10 hd-s2">
                                                    <p className="text-left">Standards Reference</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">5.</p>
                                                </td>
                                                <td className="tb-input-value pl10 hd-s2">
                                                    <p className="text-left">Other (please specify)</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">6.</p>
                                                </td>
                                                <td className="tb-input-value pl10 hd-s2">
                                                    <p className="text-left">Estimated Cost Impacte</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">7.</p>
                                                </td>
                                                <td className="tb-input-value pl10 hd-s2">
                                                    <p className="text-left">Estimated Time Impact</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">8.</p>
                                                </td>
                                                <td className="tb-input-value pl10 hd-s2">
                                                    <p className="text-left">Other Possible consequenses</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <table className="mrt20">
                                                <tbody>
                                                    <tr>
                                                        <td className="hd-b">
                                                            <p>Details</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="input-textarea">
                                                            <textarea defaultValue={""} />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-4">
                                    <div className="col-lg-12 text-left ">
                                        <table className="table-bottom-sig">
                                            <tbody>
                                                <tr className="bottom-sig-tr2-box">
                                                    <td className="input-td">
                                                        <p className="s2">Approved by (Owner rep name):</p>
                                                    </td>
                                                    <td>
                                                        <p className="s1">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                defaultValue=""
                                                            />
                                                        </p>
                                                    </td>
                                                </tr>
                                                <tr className="bottom-sig-tr2-box">
                                                    <td className="input-td">
                                                        <p className="s2">Date of approval:</p>
                                                    </td>
                                                    <td>
                                                        <p className="s1">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                defaultValue=""
                                                            />
                                                        </p>
                                                    </td>
                                                </tr>
                                                <tr className="bottom-sig-tr2-box">
                                                    <td className="input-td">
                                                        <p className="s2">Cost Impact:</p>
                                                    </td>
                                                    <td>
                                                        <p className="s1">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                defaultValue=""
                                                            />
                                                        </p>
                                                    </td>
                                                </tr>
                                                <tr className="bottom-sig-tr2-box">
                                                    <td className="input-td">
                                                        <p className="s2">Time Impact:</p>
                                                    </td>
                                                    <td>
                                                        <p className="s1">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                defaultValue=""
                                                            />
                                                        </p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="tr-info mt-4">
                                    <p className="text-left" style={{ color: "#0077e2" }}>
                                        NOTE: Enter date of approval/ cost impact/ time impact as above
                                        in Variation Order Index/ Register
                                    </p>
                                </div>
                                <div className="row mt-4"></div>
                                <div className="row mt-4">
                                    <div className="col-lg-12 text-left ">
                                        <a
                                            href="ship-inspection-progress-list.php"
                                            className="btn btn-success"
                                            style={{
                                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                                borderColor: "#2b5a7e"
                                            }}
                                        >
                                            Submit
                                        </a>
                                        <button
                                            type="reset"
                                            className="btn btn-danger ms-3"
                                            style={{
                                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                                borderColor: "#2b5a7e"
                                            }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default VariationOrderForm